import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card ${_ctx.cardClasses}`)
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("div", { class: "card-title" }, [
        _createElementVNode("h2", null, "Statement")
      ]),
      _createElementVNode("div", { class: "card-toolbar" }, [
        _createElementVNode("ul", {
          class: "nav nav-stretch fs-5 fw-bold nav-line-tabs nav-line-tabs-2x border-transparent",
          role: "tablist"
        }, [
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("a", {
              class: "nav-link text-active-primary active",
              "data-bs-toggle": "tab",
              role: "tab",
              href: "#kt_customer_view_statement_1"
            }, " This Year ")
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("a", {
              class: "nav-link text-active-primary ms-3",
              "data-bs-toggle": "tab",
              role: "tab",
              href: "#kt_customer_view_statement_2"
            }, " 2020 ")
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("a", {
              class: "nav-link text-active-primary ms-3",
              "data-bs-toggle": "tab",
              role: "tab",
              href: "#kt_customer_view_statement_3"
            }, " 2019 ")
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("a", {
              class: "nav-link text-active-primary ms-3",
              "data-bs-toggle": "tab",
              role: "tab",
              href: "#kt_customer_view_statement_4"
            }, " 2018 ")
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "card-body pb-5" }, [
      _createElementVNode("div", {
        id: "kt_customer_view_statement_tab_content",
        class: "tab-content"
      }, [
        _createElementVNode("div", {
          id: "kt_customer_view_statement_1",
          class: "py-0 tab-pane fade active show",
          role: "tabpanel"
        }),
        _createElementVNode("div", {
          id: "kt_customer_view_statement_2",
          class: "py-0 tab-pane fade",
          role: "tabpanel"
        }),
        _createElementVNode("div", {
          id: "kt_customer_view_statement_3",
          class: "py-0 tab-pane fade",
          role: "tabpanel"
        }),
        _createElementVNode("div", {
          id: "kt_customer_view_statement_4",
          class: "py-0 tab-pane fade",
          role: "tabpanel"
        })
      ])
    ], -1)
  ]))], 2))
}